import { isMenaCountry } from "@template/state/modules/menaBanner/isMenaCountry";
import { getHasWelcomeMessageBeenDismissed } from "../dismissalTracking/getHasWelcomeMessageBeenDismissed";
import { getIsPageCountHighEnough } from "../pageCountTracking/getIsPageCountHighEnough";

export const getShouldDisplay = async ({ geoCountry, browseCountry }) => {
  if (
    geoCountry === browseCountry ||
    getHasWelcomeMessageBeenDismissed() ||
    !getIsPageCountHighEnough() ||
    (await isMenaCountry(geoCountry))
  ) {
    return false;
  }

  return true;
};
